/**
 * 악덕알리미 월별 통계 (/b/stats) — 서버가 준 달별 값을 6개월씩 넘겨 본다. 값은 막대 위 숫자로 보인다.
 */
const SPAN = 6;
const LABEL_H = 21;   // 막대 위 숫자 자리 — _stats.scss .b-stats__plot em (14px × 1.2 + 아래 여백 4px)

export default class Stats {
    initialize() {
        this.data = JSON.parse(document.getElementById('page-data').textContent);
        this.end = this.data.months.length;   // 지금 보는 구간의 끝(포함 안 함) — 처음은 이번 달까지
        this.bind();
        this.render();
    }

    bind() {
        $('.js-prev').on('click', () => this.move(Math.max(SPAN, this.end - SPAN)));
        $('.js-next').on('click', () => this.move(Math.min(this.data.months.length, this.end + SPAN)));
    }

    move(end) {
        this.end = end;
        this.render();
    }

    rangeText(from, to) {
        const [y1, m1] = from.split('-').map(Number);
        const [y2, m2] = to.split('-').map(Number);
        return `${y1}년 ${m1}월 ~ ${y1 === y2 ? '' : `${y2}년 `}${m2}월`;
    }

    render() {
        const { months } = this.data;
        const start = this.end - SPAN;
        const shown = months.slice(start, this.end);
        const current = months[months.length - 1];

        $('.js-range').text(this.rangeText(shown[0], shown[shown.length - 1]));
        $('.js-prev').prop('disabled', start === 0);
        $('.js-next').prop('disabled', this.end === months.length);

        $('.b-stats__bars').each((i, el) => {
            const values = this.data[el.dataset.key].slice(start, this.end);
            const max = Math.max(1, ...values.map((v) => v || 0));
            el.innerHTML = shown.map((ym, j) => this.barHtml(ym, values[j], max, ym === current)).join('');
            $(el).find('.b-stats__fill').each((k, fill) => {
                // 숫자 자리(LABEL_H)를 뺀 높이를 최댓값 대비 비율로 나눠야 막대끼리 비율이 맞는다
                fill.style.height = `calc((100% - ${LABEL_H}px) * ${(values[k] || 0) / max})`;
            });
        });
    }

    barHtml(ym, value, max, isCurrent) {
        const none = value === null;
        const cls = `b-stats__bar${none ? ' is-none' : ''}${isCurrent ? ' is-current' : ''}`;
        const num = none ? '-' : Number(value).toLocaleString();
        return `<div class="${cls}">
            <div class="b-stats__plot"><em>${num}</em><i class="b-stats__fill"></i></div>
            <span>${Number(ym.split('-')[1])}월</span>
        </div>`;
    }
}
